// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import sessionAgendaItemEntity from './entities/session-agenda-item.json';
import sessionAgendaItemMenu from '../pages/session-agenda-item/menu.json';
import sessionAgendaItemFullForm from '../pages/session-agenda-item/forms/full.json';
import sessionAgendaItemContextForm from '../pages/session-agenda-item/forms/context.json';
import sessionAgendaItemMiniForm from '../pages/session-agenda-item/forms/mini.json';
import sessionAgendaItemLookupForm from '../pages/session-agenda-item/forms/lookup.json';
import sessionAgendaItemTableView from '../pages/session-agenda-item/views/table.json';
import sessionAgendaItemCardsView from '../pages/session-agenda-item/views/cards.json';
import sessionAgendaItemDashboardView from '../pages/session-agenda-item/views/dashboard.json';

/** Тип запису «Питання порядку денного» зі сторінками пакета: меню, форми та подання з pages/session-agenda-item/. */
export const sessionAgendaItemDefinition: IRecordTypeDefinition = {
  ...sessionAgendaItemEntity,
  views: assembleViewSet({
      table: sessionAgendaItemTableView,
      cards: sessionAgendaItemCardsView,
      dashboard: sessionAgendaItemDashboardView,
  }),
  form: sessionAgendaItemFullForm,
  forms: { full: sessionAgendaItemFullForm, context: sessionAgendaItemContextForm, mini: sessionAgendaItemMiniForm, lookup: sessionAgendaItemLookupForm },
  menu: sessionAgendaItemMenu,
} as IRecordTypeDefinition;
